import { Navigate, Route, Routes } from 'react-router';
import { RotaProtegida } from './componentes/RotaProtegida';
import { ProvedorInterno } from './lib/interno-tempo-real';
import { Atendimento } from './paginas/Atendimento';
import { BoasVindas } from './paginas/BoasVindas';
import { Conta } from './paginas/Conta';
import { Conversas } from './paginas/Conversas';
import { Entrar } from './paginas/Entrar';
import { MeusDados } from './paginas/MeusDados';
import { Privacidade } from './paginas/Privacidade';

export function App() {
  return (
    // A conversa interna fica conectada no aplicativo inteiro, e não só na tela dela: é
    // essa conexão que diz à equipe que o técnico está com o MyMAXX aberto — inclusive
    // enquanto ele está no meio de um atendimento, que é onde ele passa o tempo.
    <ProvedorInterno>
      <Routes>
        <Route path="/" element={<BoasVindas />} />
        <Route path="/entrar" element={<Entrar />} />
        <Route path="/atendimento" element={<Atendimento />} />
        <Route path="/privacidade" element={<Privacidade />} />
        <Route element={<RotaProtegida />}>
          <Route path="/conta" element={<Conta />} />
          {/* Conversa interna: só faz sentido com sessão, e hoje só o técnico participa de
            canal — o cliente comum entra aqui e vê a lista vazia. */}
          <Route path="/conversas" element={<Conversas />} />
          {/* Os direitos da LGPD em tela própria: continuam a dois toques, e fora do
            caminho de quem só quer falar com a MAXX. */}
          <Route path="/conta/meus-dados" element={<MeusDados />} />
        </Route>
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </ProvedorInterno>
  );
}
